export const WBNB = {
  56: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  97: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
};
export const TALLY = {
  56: "0xab15B3eeC70514308B0Ad65E8B760398c5839947",
  97: "0x6468B39e49b5E185f321d6C4E5d7FCE949724697",
};
export const XRP = {
  56: "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
};
export const ETH = {
  56: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
};
export const ADA = {
  56: "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
};
export const DOT = {
  56: "0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402",
};
export const LINK = {
  56: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
};
export const BTCB = {
  56: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
};
export const DOGE = {
  56: "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
};
export const AVAX = {
  56: "0x1CE0c2827e2eF14D5C4f29a091d735A204794041",
};
export const LTC = {
  56: "0x4338665CBB7B2485A8855A139b75D5e34AB0DB94",
};
export const UNI = {
  56: "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
};
export const TALLYSWAP_FACTORY_ADDRESS = {
  56: "0x7f07244476692ef2657bd33920760dfb11521dad",
  97: "0xebe4c1f0a9b09ac05e61d9665cadcb180671972f",
};
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const RANDOM_ADDRESS = "0x0000000000000000000000000000000000000001";
export const TALLYSWAP_ROUTER_ADDRESS = {
  56: "0x6e60f4FE6dD11c4A4468C0dFb10dbF5e11a2EF79",
  97: "0xe42F1aeCB477FA6CcDF9cA24EAcc15f2F1F1CfaB",
};
export const MASTERCHEF_ADDRESS = {
  56: "0x7Dd92B4584E9027E37f906302604d6b7e76c71e9",
  97: "0x43A78E0b7A11FdAC3A8f605ef91d2159Dbbcd09c",
};
